import creator from '@signavio/kraken'
import type { Reducer } from 'reduce-reducers'

import * as apiTypes from './types'

const { reducer, saga, connect, actions, useApi } = creator(apiTypes)
const typedReducer: Reducer<unknown> = reducer

export { typedReducer as reducer, saga, connect, actions, useApi }
